<template>
    <div class="unit" v-if="unit">
        <div class="unit-header">
            <div class="flex flex-align">
                <input type="text" class="search medium" placeholder="Search Resources" v-model="search" />
            </div>
            <h1>{{unit.title}}</h1>
        </div>
        <div class="resources">
            <resource v-for="resource of results" :content="resource" :key="resource.id" />
        </div>
    </div>
</template>

<script>
    import Options from '@/components/modals/Options.vue';

    export default {
        name: 'ProductUnit',
        props: {
            unit: Object
        },
        data(){
            return {
                loading: true,
                search: '',
                contents: []
            };
        },
        watch: {
            '$route.params.unit': {
                immediate: true,
                handler(){
                    if(this.$route.params.unit){
                        //Load the product snapshots from the server.
                        this.$http.get(`/contents/${this.$route.params.unit}/children`)
                        .then(response => this.contents = response.$data)
                        .then(() => {
                            //We want to load attachments for all of the lesson plan resources (for now).
                            const plans = new Map();

                            for(const plan of this.contents.filter(content => content.type === 'lessonPlan')){
                                //Set an attachments array on the plan.
                                plan.attachments = [];

                                //Save it for later.
                                plans.set(plan.id, plan);
                            }

                            if(plans.size){
                                //TODO this is weird because there are a LOT more items than expected.
                                this.$http.get(`/contents`, {
                                    params: {
                                        type: 'widget',
                                        contentType: 'resource-reference',
                                        parentId: Array.from(plans.keys()).join(','),
                                        deep: true
                                    }
                                })
                                .then(response => {
                                    for(const attachment of response.$data){
                                        plans.get(attachment.parent.id).attachments.push(attachment);
                                    }
                                })
                                .catch(error => this.$toasted.error('Failed to load attachments.'));
                            }
                        })
                        .catch(error => this.$toasted.error('There was an error loading this product.'));
                    }
                }
            }
        },
        methods: {

        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            results(){
                if(this.search){
                    return this.contents.filter(content => {
                        return content.title.toLowerCase().includes(this.search.toLowerCase());
                    });
                }

                return this.contents;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @section-font-size: 24px;
    @number-width: 40px;

    .unit-header
    {
        max-width: 800px;
        padding-bottom: 50px;
        border-bottom: 1px solid @e4;

        h1
        {
            margin-top: 30px;
        }
    }

    .product-assignments
    {
        padding: 50px;
    }

    .product-search
    {
        padding-bottom: 25px;
    }

    .search
    {
        max-width: 400px;
    }

    .product
    {
        padding: 40px 50px;

        .toc
        {
            // padding-top: 50px;
        }
    }

    .assignment
    {
        padding: 4px 0;
        line-height: 24px;
        margin-bottom: 15px;

        .number
        {
            width: @number-width;
            font-size: 15px;
            color: var(--secondary-text-color);
            position: absolute;
            left: -40px;
            top: 4px;
        }

        .title
        {
            cursor: pointer;
            font-size: 15px;
            color: var(--primary-text-color);

            &::after
            {
                content: "";
                position: absolute;
                border-bottom: 1px solid var(--secondary-text-color);
                top: 0;
                left: 0;
                bottom: -2px;
                pointer-events: none;
                width: 0;
                transition: width ease 0.2s;
            }

            &:hover, &:active
            {
                &::after
                {
                    width: 100%;
                }
            }
        }

        .questions-icon, .simulations-icon
        {
            width: 24px;
            height: 24px;
            opacity: 0.2;

            &.active
            {
                opacity: 1;
            }
        }

        .questions-icon
        {
            background: url('~@/assets/icons/grey/questions.svg') 5px 7px no-repeat;
            background-size: 14px auto;
        }

        .simulations-icon
        {
            background: url('~@/assets/icons/grey/simulations.svg') 2px 7px no-repeat;
            background-size: 22px auto;
        }

        .text-button
        {
            margin-right: 10px;
            font-size: 15px;
            font-weight: 400;
            line-height: 24px;
            height: 24px;
        }
    }

    .assignment-course
    {
        font-size: 13px;
        color: var(--secondary-text-color);
        line-height: 16px;
        margin-top: 2px;
    }

    .assignment-state
    {
        font-size: 13px;
        color: var(--secondary-text-color);
        line-height: 18px;

        &.started
        {
            color: var(--primary-text-color);
        }

        &.submitted
        {
            color: @base;
        }
    }

    .assignment-delete
    {
        font-size: 13px;
        line-height: 18px;
        color: @red;
        transition: opacity ease 0.2s;

        &:hover, &:active
        {
            opacity: 0.7;
        }
    }

    .assignment-options
    {
        align-items: flex-end;
    }

    .assignment-due
    {
        font-size: 12px;
        color: var(--secondary-text-color);
        line-height: 16px;
    }
</style>